import React from 'react';
import cn from 'classnames';

import { Spinner, SpinnerSize } from 'widget/shared/ui/Spinner';
import type { SpinnerSizeType } from 'widget/shared/ui/Spinner';

import styles from './LoaderSpinner.module.scss';

export const LoaderSpinnerSize = SpinnerSize;

type Props = {
  className?: string;
  size?: SpinnerSizeType;
  centered?: boolean;
};

const LoaderSpinner: React.FC<Props> = ({
  className,
  size = LoaderSpinnerSize.m,
  centered = false
}) => {
  return (
    <div
      className={cn(
        styles.spinner,
        centered && styles.spinner_centered,
        className
      )}
    >
      <Spinner size={size} />
    </div>
  );
};

export default React.memo(LoaderSpinner);
